var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseAppletsIcon = function SvgCloseAppletsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M14.653 8.869H6.965a.19.19 0 0 1-.188-.188V5.665a.754.754 0 0 0-1.29-.535L1.17 9.464a.754.754 0 0 0 0 1.063l4.319 4.32a.76.76 0 0 0 .535.218.8.8 0 0 0 .286-.053.75.75 0 0 0 .468-.7v-3.016a.19.19 0 0 1 .188-.188h7.688a1.13 1.13 0 1 0 0-2.262zM17.82 4.55a1.13 1.13 0 0 0-1.131 1.13v8.631a1.13 1.13 0 1 0 2.261 0v-8.63a1.13 1.13 0 0 0-1.13-1.131"
  })));
};
export { SvgCloseAppletsIcon as ReactComponent };